import { Identifiable, Project } from "@planzone/dto";

type ProjectPortfolio = {
  name: string;
  color: string;
  description: string;
  projects: Identifiable<Project>[];
};

const projectPortfolio: ProjectPortfolio = {
  name: "",
  color: "",
  description: "",
  projects: [],
};

export type { ProjectPortfolio };

export { projectPortfolio };
